import { useMemo } from 'react';
import { useQueryGetSubscriptionsV2 } from 'state/internal/getSubscriptions';
import type { SubscriptionDetailsV2Response } from 'state/internal/getSubscriptionDetails/types';
import { compareAsc } from 'date-fns';
import { getIdFromShopifyFormattedId } from 'shared/utils/shopify/ids';

export const useGetNextSubscriptionOrderV2 = (
  subscriptionId?: string
): {
  isLoading: boolean;
  nextSubscriptionOrder?: SubscriptionDetailsV2Response | null;
} => {
  const { data: subscriptions, isPending: isSubscriptionsLoading } = useQueryGetSubscriptionsV2();

  const activeSubscriptions =
    useMemo(
      () =>
        subscriptions
          ?.filter((i) => i.is_active)
          .sort((a, b) => a.next_order_date - b.next_order_date) || [],
      [subscriptions]
    ) || [];

  if (isSubscriptionsLoading) {
    return {
      isLoading: true
    } as const;
  }

  const nextSubscriptionOrder = activeSubscriptions
    .filter((i) =>
      subscriptionId ? getIdFromShopifyFormattedId(i.shopify_contract_id) === subscriptionId : true
    )
    .reduce((acc: SubscriptionDetailsV2Response, curr: SubscriptionDetailsV2Response) => {
      if (!acc) return curr;

      return compareAsc(
        new Date(acc.next_order_date * 1000),
        new Date(curr.next_order_date * 1000)
      ) < 0
        ? acc
        : curr;
    }, null);

  return {
    isLoading: false,
    nextSubscriptionOrder
  } as const;
};
